import Vue from "vue";
import Router from "vue-router";
import { getAuthUser } from "./utils";
import store from '@/store';

Vue.use(Router);

let router = new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			name: "index",
			meta: {
				// analytics: "LandingPage",
				layout: "LandingPageLayout"
			},
			component: () => import(/* webpackChunkName: "LandingPage" */"./views/Index")
		},
		{
			path: "/investor",
			name: "investor",
			beforeEnter: (to, from, next) => {
				next({ name: "index" })
			},
			meta: {
				// analytics: "InvestorPage",
				layout: "LandingPageLayout",
			},
			component: () => import(/* webpackChunkName: "InvestorPage" */"./views/Investor")
		},
		{
			path: "/privacy-policy",
			name: "privacy_policy",
			meta: {
				// analytics: "PrivacyPolicy Page",
				layout: "LandingPageLayout",
			},
			component: () => import(/* webpackChunkName: "PrivacyPolicy" */"./views/PrivacyPolicy")
		},
		{
			path: "/terms_and_conditions",
			name: "terms_of_service",
			meta: {
				// analytics: "Terms of Service Page",
				layout: "LandingPageLayout"
			},
			component: () => import(/* webpackChunkName: "TermsOfService" */"./views/TermsOfService")
		},
		{
			path: "/cookie-policy",
			name: "cookie-policy",
			meta: {
				// analytics: "Cookie Policy Page",
				layout: "LandingPageLayout"
			},
			component: () => import(/* webpackChunkName: "CookiePolicy" */"./views/CookiePolicy")
		},
		{
			path: "/contact",
			name: "contact",
			meta: {
				layout: "LandingPageLayout"
			},
			component: () => import(/* webpackChunkName: "ContactUs" */"./views/ContactUs")
		},
		{
			path: "/:monitor_uuid/post-detail/:post_id",
			name: "postdetail",
			props: true,
			meta: {
				// analytics: "Post Detail Page",
				layout: "DefaultLayout",
				requiresAuth: true
			},
			component: () => import(/* webpackChunkName: "PostDetail" */"./views/PostDetail")
		},
		{
			path: "/mention/:monitor_uuid",
			name: "mention",
			props: true,
			meta: {
				//analytics: 'Mention Page',
				layout: "DefaultLayout",
				requiresAuth: true
			},
			component: () => import(/* webpackChunkName: "Mention"*/"./views/Mention.vue")
		},
		{
			path: "/sentiment/:monitor_uuid",
			name: "sentiment",
			props: true,
			meta: {
				// analytics: "Sentiment Page",
				layout: "DefaultLayout",
				requiresAuth: true
			},
			component: () => import(/* webpackChunkName: "Sentiment" */"./views/Sentiment.vue")
		},
		{
			path: "/compare/:monitor_uuid",
			name: "comparison",
			props: true,
			meta: {
				layout: "DefaultLayout",
				requiresAuth: true
			},
			component: () => import(/* webpackChunkName: "MonitorComparison" */"./views/MonitorComparison.vue")
		},
		{
			path: "/monitor-list",
			name: "monitor-list",
			meta: {
				//analytics: "Monitor List Page",
				layout: "DefaultLayout",
				requiresAuth: true
			},
			component: () => import(/* webpackChunkName: "MonitorList" */"./views/MonitorList")
		},
		{
			path: "/monitor/create",
			name: "monitor-create",
			meta: {
				//analytics: "Monitor Create Page",
				layout: "DefaultLayout",
				requiresAuth: true
			},
			props: { create: true },
			component: () => import(/* webpackChunkName: "MonitorCreate" */"./views/MonitorSetting")
		},
		{
			path: "/monitor/:monitor_uuid/edit",
			name: "edit-monitor",
			meta: {
				//analytics: "Monitor Edit Page",
				layout: "DefaultLayout",
				requiresAuth: true
			},
			props: { create: false },
			component: () => import(/* webpackChunkName: "MonitorEdit" */"./views/MonitorSetting")
		},
		{
			path: "/global-settings",
			name: "global-settings",
			meta: {
				//analytics: "GlobalSettings Page",
				layout: "DefaultLayout",
				requiresAuth: true
			},
			component: () => import(/* webpackChunkName: "GlobalSetting" */"./views/GlobalSettings"),
			beforeEnter: (to, from, next) => {
				let user = router.app.$session.get("authUser") || {};
				let authUser = getAuthUser(user);
				if (authUser.is_user) {
					next({ name: "monitor-list" });
				} else {
					next()
				}
			}
		},
		{
			path: "/authorizing",
			name: "authorizing",
			meta: {
				layout: "SimpleLayout"
			},
			component: () => import(/* webpackChunkName: "Authorize" */"./views/Authorize"),
			props: route => ({
				code: route.query.code,
				error: route.query.error
			}),
			beforeEnter: (to, from, next) => {
				let user = router.app.$session.get("authUser") || {};
				let authUser = getAuthUser(user);
				if (authUser.isAuthorized === 'Unauthorized') {
					next();
				} else {
					next({ name: from.name });
				}
			}
		},
		{
			path: "/audience/:monitor_uuid",
			props: true,
			meta: {
				layout: "DefaultLayout",
			},
			children: [
				{
					path: '',
					props: true,
					name: "audience-list",
					meta: {
						layout: "DefaultLayout",
					},
					component: () => import(/* webpackChunkName: "AudienceAnalysesList" */'./components/Audience/AudienceAnalysesList')
				},
				{
					path: 'detail',
					name: "audience-analysis",
					meta: {
						layout: "DefaultLayout",
					},
					beforeEnter: (to, from, next) => {
						if (store.state.audience.audienceUrl) {
							next()
						} else {
							next({ name: 'audience-list', params: { monitor_uuid: to.params.monitor_uuid } });
						}
					},
					component: () => import(/* webpackChunkName: "AudienceAnalysis" */'./components/Audience/AudienceAnalysis')
				}
			],
			component: () => import("./views/Audience"),
		},
		{
			path: '/platform/:monitor_uuid/:platform',
			name: 'platform',
			props: true,
			meta: {
				layout: 'DefaultLayout'
			},
			component: () => import(/* webpackChunkName: "Platform" */ './views/Platform'),
		},
		{
			path: '*',
			name: 'notfound',
			meta: {
				layout: "SimpleLayout"
			},
			component: () => import("./views/NotFound")
		}
	],
	scrollBehavior(to, from) {
		if (to.name === 'postdetail')
			return { x: 0, y: 0 }
	}
});

router.beforeEach(function (to, from, next) {
	if (to.matched.some(a => a.meta.requiresAuth)) {
		let user = router.app.$session.get("authUser") || {};
		let authUser = getAuthUser(user);
		router.app.$ua.trackView(`https://bindez.com${to.fullPath} view by user ${user.email}.`, true);
		if (authUser.isAuthorized === 'Unauthorized') {
			window.location.href = `${process.env.VUE_APP_REDIRECT_URL}/login`;
		} else {
			next()
		}
	} else {
		router.app.$ua.trackView(`https://bindez.com${to.fullPath} view by user.`, true);
		next();
	}
});


export default router;
